import React, { FC } from 'react';
import { Form, Formik, FormikHelpers } from 'formik';
import { IMessage } from 'core/interface/contact';
import { InputType } from 'core/enum/inputType';
import FormField from 'components/FormField/Index';
import { initialValues, validation } from './form';
import useLocales from '../../hooks/useLocales';

import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import Navbar from 'components/Navbar';
import Footer from 'components/Footer/Index';

import './index.scss';
import { ContactService } from 'services/contact/contact';
import { useSnackbar } from 'notistack';

const ContactUs: FC = (): JSX.Element => {
  const { t } = useLocales();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (
    values: IMessage,
    e: FormikHelpers<IMessage>
  ): Promise<void> => {
    try {
      await ContactService.sendMessage(values);

      enqueueSnackbar(t('Your message has been sent successfully!'), {
        variant: 'success'
      });

      e.resetForm();
    } catch (error) {
      enqueueSnackbar(t('Failed to send message'), {
        variant: 'error'
      });
    }
  };

  return (
    <div
      className="contactUs"
      style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
    >
      <Navbar />
      <div className="main" style={{ flex: 1 }}>
        <div className="contact">
          <div className="contact__card">
            <Image name="contact.svg" className="contact__image" />
            <div className="contact__form">
              <div className="contact__form__left">
                <h1 className="contact__form__left-title">{t('Contact Us')}</h1>
                <Formik
                  initialValues={initialValues}
                  onSubmit={(values, actions) => handleSubmit(values, actions)}
                  validationSchema={validation(t)}
                >
                  {({ isValid, setFieldValue, errors, values }) => (
                    <Form>
                      <div className="field">
                        <span className="label">{t('Name')}</span>
                        <FormField
                          inputClassName="input"
                          fieldName="name"
                          type={InputType.text}
                          placeholder="Name"
                        />
                      </div>
                      <div className="field">
                        <span className="label">{t('Email')}</span>
                        <FormField
                          inputClassName="input"
                          fieldName="email"
                          type={InputType.email}
                          placeholder={t('Email')}
                        />
                      </div>
                      <div className="field">
                        <span className="label">{t('Phone Number')}</span>
                        <FormField
                          inputClassName="input"
                          fieldName="phone"
                          type={InputType.text}
                          placeholder={t('Phone Number')}
                        />
                      </div>
                      <div className="field">
                        <span className="label">{t('Message')}</span>
                        <textarea
                          className={`input area ${
                            errors.message ? 'error' : ''
                          }`}
                          placeholder="Message"
                          value={values.message}
                          onChange={(e) =>
                            setFieldValue('message', e.target.value)
                          }
                        />
                      </div>
                      <Button
                        t={t}
                        title="Send"
                        type="submit"
                        className={`send ${!isValid ? 'invalid-btn' : ''}`}
                      />
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;
